import { pushGenericEventData } from './generic-event';

const baseEventParams = {
  eventCategory: 'Flight Grid',
  eventAction: 'recent searches modal',
  eventValue: null
};

export const fireRecentSearchesImpressionEvent = (numberOfRecentSearches: number) => {
  return pushGenericEventData(
    { ...baseEventParams, eventLabel: 'recent searches modal impression', eventType: 'nonInteraction' },
    { genericValue1: numberOfRecentSearches.toString() }
  );
};

export const fireRecentSearchesOptionSelectEvent = () => {
  return pushGenericEventData({ ...baseEventParams, eventLabel: 'recent searches modal clicks', eventType: 'interaction' });
};

export const fireRecentSearchesExitEvent = (reason: 'exit button' | 'esc') => {
  return pushGenericEventData(
    { ...baseEventParams, eventLabel: 'recent searches modal clicks', eventType: 'interaction' },
    { genericValue1: 'exit', genericValue2: reason }
  );
};

export const fireRecentSearchesClearEvent = () => {
  return pushGenericEventData(
    { ...baseEventParams, eventLabel: 'recent searches modal clicks', eventType: 'interaction' },
    { genericValue2: 'clear recent searches button' }
  );
};
